export default __webpack_public_path__ + "static/media/menu_rooms.48dd18ea.svg";